import { SizeType } from 'antd/es/config-provider/SizeContext';
import React, { FC } from 'react';
import { FieldOption, StatusGroup, TaskType } from 'api/tasks';
import { StatusIndicator } from 'components/molecules/status-indicator';
import { IconShell } from '../icon-shell';

export const StatusPickerOptionIcon: FC<{
  data: FieldOption<StatusGroup>;
  progress: number;
  showTooltip?: boolean;
  size?: SizeType;
  type: TaskType;
}> = ({ data, progress, showTooltip = true, size = 'small', type }) => (
  <IconShell
    size={size}
    icon={
      <StatusIndicator
        progress={progress}
        showTooltip={showTooltip}
        status={data as Required<FieldOption<StatusGroup>>}
        type={type}
      />
    }
  />
);
